import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Header.css'

const Header = () => {
    return (
        <Navbar bg="dark" variant="dark">
            <Container>
                <Nav className="mx-auto my-4">
                    <Link className='manu' to={'/'}>Home</Link>
                    <Link className='manu' to={'/reviews'}>Reviews</Link>
                    <Link className='manu' to={'/dashboard'}>Dashboard</Link>
                    <Link className='manu' to={'/blogs'}>Blogs</Link>
                    <Link className='manu'to={'/about'}>About</Link>
                </Nav>
            </Container>
        </Navbar>
    );
};

export default Header;